import { ComponentProps } from 'preact/compat';

import ZoolifeSVG from '@/components/ZoolifeLogo/svg';
import { cn } from '@/lib/utils';
import { HabitatListItem } from '@/queries/habitats/types';

interface UserProductImageProps extends Omit<ComponentProps<'div'>, 'children'> {
  habitat?: Pick<HabitatListItem, 'profileImage' | 'title'>;
}

const UserProductImage = ({ habitat, className, ...props }: UserProductImageProps) => {
  const { profileImage, title } = habitat ?? {};

  return (
    <div
      className={cn(
        'relative flex aspect-square items-center justify-center overflow-hidden rounded-lg bg-primary-green',
        className,
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {profileImage ? (
        <img
          src={profileImage}
          alt={title || 'Habitat profile image'}
          className="preflight preflight-img absolute inset-0 object-cover"
        />
      ) : (
        <ZoolifeSVG className="mx-1.5 text-white" />
      )}
    </div>
  );
};

export default UserProductImage;
